// @hooks
import useSWR from "swr";

// @utils
import { chartApiUrl, fetcher } from "@/utils";

const endpoint = `${process.env.NEXT_PUBLIC_API_URL_V1}/inflation`;

export function useStockToFlow(
  shouldFetch: boolean = true,
  variation?: string,
) {
  return useSWR(
    shouldFetch ? chartApiUrl(`${endpoint}/stock-to-flow`, variation) : null,
    fetcher,
  );
}

export function useSupply(shouldFetch: boolean = true, variation?: string) {
  return useSWR(
    shouldFetch ? chartApiUrl(`${endpoint}/supply`, variation) : null,
    fetcher,
  );
}
